import React from "react";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import ModalReportStyles from "../../../../styles/pages/Summaries/ModalReportStyles";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";
import {
    IFilter,
    IFilterType,
} from "../../../../context/interfaces/IFilterDataContext";

const { BtnPrimary, DefaultButtonLink, BtnOutlinePrimary } = ButtonStyles;
const { StyledContainerBtns } = ModalReportStyles;

interface IAction {
    handleSetFilter: (arg0: IFilter) => void;
    removingItems: () => void;
    filter: IFilter;
}

const ActionSelectData: React.FC<IAction> = ({
    handleSetFilter,
    removingItems,
    filter,
}) => {
    const { modalFilterOptions } = useFilterData();

    const isEditItem = !!(filter[modalFilterOptions.key] as IFilterType)
        .selectedValue.length;

    const addItems = isEditItem ? "Editar Itens" : "Adicionar Selecionados";
    const addAllItems = isEditItem ? "Selecionar Todos" : "Adicionar Todos";

    const handleItemsUpdate = (newFilter: IFilter) => {
        handleSetFilter({
            ...newFilter,
            openModal: false,
        });
    };

    const handleCheckAll = () => {
        const newFilter: IFilter = {
            ...filter,
            [modalFilterOptions.key]: {
                ...(filter[modalFilterOptions.key] as IFilterType),
                selectedValue: [
                    ...(filter[modalFilterOptions.key] as IFilterType).list,
                ],
            },
        };
        handleItemsUpdate(newFilter);
    };

    const handleCheckSelected = () => {
        const newFilter: IFilter = {
            ...filter,
            [modalFilterOptions.key]: {
                ...(filter[modalFilterOptions.key] as IFilterType),
                selectedValue: [...modalFilterOptions.tempSelectedValue],
            },
        };
        handleItemsUpdate(newFilter);
    };

    const hasValidList = !!(filter[modalFilterOptions.key] as IFilterType).list;

    return (
        <StyledContainerBtns style={{ marginTop: "30px", gap: "20px" }}>
            <BtnPrimary
                disabled={!hasValidList}
                onClick={() => handleCheckSelected()}
            >
                {addItems}
            </BtnPrimary>
            <BtnOutlinePrimary
                disabled={!hasValidList}
                onClick={() => handleCheckAll()}
            >
                {addAllItems}
            </BtnOutlinePrimary>
            <DefaultButtonLink onClick={() => removingItems()}>
                Cancelar
            </DefaultButtonLink>
        </StyledContainerBtns>
    );
};

export default ActionSelectData;
